import { render, staticRenderFns } from "./delivery-proof.vue?vue&type=template&id=d4d76cac&"
import script from "./delivery-proof.vue?vue&type=script&lang=js&"
export * from "./delivery-proof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports